import { render, staticRenderFns } from "./FurtherReading.vue?vue&type=template&id=3b6d8d79"
import script from "./FurtherReading.vue?vue&type=script&lang=js"
export * from "./FurtherReading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports